import React from 'react';
import { SemanticToastContainer } from 'react-semantic-toasts';
import { useDispatch, useSelector } from 'react-redux';
import {
  doBulkOutletUpdate,
  doShowLogs,
} from 'state/bulkOutletUpdateExpiration/actions';
import MainPage from 'pages/BulkOutletUpdateExpiration/MainPage';
import ProcessingPage from 'pages/BulkOutletUpdateExpiration/ProcessingPage';

function getOutletIdsArray(strArray) {
  return [...new Set(strArray.split('\n'))]
    .map(oId => parseInt(oId, 10))
    .filter(oId => !Number.isNaN(oId));
}

function BulkOutletUpdateExpiration() {
  const dispatch = useDispatch();

  const onSubmit = values =>
    dispatch(
      doBulkOutletUpdate(
        getOutletIdsArray(values.outlet_ids),
        values.expired_at,
        values.reason
      )
    );

  const isProcessing = useSelector(
    state => state.bulkOutletUpdateExpiration.isProcessing
  );

  return (
    <>
      <SemanticToastContainer />
      <h1>Bulk Outlet Expiration Update</h1>
      <br />
      {isProcessing ? (
        <ProcessingPage />
      ) : (
        <MainPage
          onSubmit={onSubmit}
          onShowLogButtonClicked={() => dispatch(doShowLogs())}
        />
      )}
    </>
  );
}

export default BulkOutletUpdateExpiration;
